import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {KMDSymbol} from "../reels/KMDSymbol";
import {S1_S2_ANIMATIONS, SPECIAL_SYMBOL_NAMES} from "../server/IKMDData";
import {KMDSound} from "../sound/KMDSound";

export class KMDS1FeatureTransform implements ISimplePresentation {

    public shouldRun(): boolean {
        return (KennethMustDie.s1CountReelStop === 2);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            s1Positions: number[] = KennethMustDie.model.s1Positions,
            s1Feature: string[] = KennethMustDie.model.gameData.s1TransformList;
        let featureCtr: number = 0;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        s1Positions.forEach((val: number, reelId: number) => {
            if (val > -1) {
                const s1Symbol: KMDSymbol = (KennethMustDie.reelView.reelModels[reelId].getStopSymbolAt(val).positionable as KMDSymbol),
                    feature: string = s1Feature[featureCtr++];
                let animName: string = "";

                switch (feature) {
                    case SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD:
                        animName = S1_S2_ANIMATIONS.X_NUDGE_WILD;
                        break;
                    case SPECIAL_SYMBOL_NAMES.X_WAYS:
                        animName = S1_S2_ANIMATIONS.X_WAYS;
                        break;
                    case SPECIAL_SYMBOL_NAMES.SM1:
                        animName = S1_S2_ANIMATIONS.SM1;
                        break;
                    case SPECIAL_SYMBOL_NAMES.SM2:
                        animName = S1_S2_ANIMATIONS.SM2;
                        break;
                    case SPECIAL_SYMBOL_NAMES.W:
                        animName = S1_S2_ANIMATIONS.W;
                        break;
                    case "M1":
                        animName = S1_S2_ANIMATIONS.M1;
                        break;
                    case "M2":
                        animName = S1_S2_ANIMATIONS.M2;
                        break;
                }

                s1Symbol.updateAnimation(SPECIAL_SYMBOL_NAMES.S);

                tl.add([
                    () => {
                        s1Symbol.hideSymbolCount();

                        // #479
                        KennethMustDie.soundPlayer.playSound(KMDSound.WIN_SCRAMBLE);
                    },
                    s1Symbol.setState(animName)
                ], 0);
                tl.add(() => {
                    const multi: number = KennethMustDie.model.gameData.multiplier[reelId][val];

                    s1Symbol.originalName = feature;

                    if (feature === SPECIAL_SYMBOL_NAMES.X_NUDGE_WILD) {
                        s1Symbol.updateAnimation(feature, multi);

                        s1Symbol.showMultiplierOnXNudge((multi || 1), -1);
                    } else if (feature === SPECIAL_SYMBOL_NAMES.X_WAYS) {
                        s1Symbol.updateAnimation(feature, multi);

                        s1Symbol.showSymbolCount(multi);
                    } else {
                        s1Symbol.updateTexture(feature, multi);
                    }
                });
            }
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}